/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'evaluation': {
    width: 14,
    height: 19,
    viewBox: '0 0 14 19',
    data: '<path pid="0" d="M7 0c.965 0 1.796.704 2.027 1.69h1.126c.468 0 .847.405.847.905V3h1.811C13.468 3 14 3.513 14 4.145v13.71c0 .632-.532 1.145-1.189 1.145H1.188C.532 19 0 18.487 0 17.855V4.145C0 3.513.532 3 1.188 3H3v-.405c0-.5.38-.905.847-.905h1.126C5.203.704 6.035 0 7 0zM3 3.981H1.188a.167.167 0 0 0-.17.164v13.71c0 .09.077.163.17.163h11.623c.094 0 .17-.073.17-.163V4.145a.167.167 0 0 0-.17-.163L11 3.98v.114c0 .5-.38.905-.847.905H3.847C3.38 5 3 4.595 3 4.095v-.114zM12 13v1H7v-1h5zm0-5v1H7V8h5zM7 1c-.502 0-.935.39-1.05.93-.107.502-.5.86-.96.86H4V4h6V2.79h-.99c-.46 0-.854-.358-.96-.86C7.935 1.39 7.502 1 7 1zM5.028 6.685l.643.63-2.279 2.33L2 8.251l.636-.636.748.748 1.644-1.679zm0 5l.643.63-2.279 2.33L2 13.251l.636-.636.748.748 1.644-1.679z" _fill="#848484" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/evaluation.js